
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_1qoee_99",
  "outline": "awsui_outline_4yi2u_1qoee_135",
  "toggle-control": "awsui_toggle-control_4yi2u_1qoee_157",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_1qoee_170",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_1qoee_173",
  "toggle-handle": "awsui_toggle-handle_4yi2u_1qoee_180",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_1qoee_195",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_1qoee_201"
};
  